module.exports = __webpack_public_path__ + "assets/media/success.d1271d0e.mp3";